const content = {
	deleteTemplateModalTitle: 'Are you sure you want to delete this template?',
	deleteTemplateModalSafeActionButton: "No, don't delete",
	deleteTemplateModalDestructiveActionButton: 'Yes, delete',
	deleteTemplateModalSubText:
		'If you ever need to make another payment template using these same details, you’ll have to manually add all the details again.',
	deleteButtonText: 'Delete Template',
};

export default content;
